var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chartData)?_c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('GChart',{ref:"geoChart",attrs:{"id":"GChart","options":_vm.optionsGeoImpacts,"data":_vm.chartData,"settings":{
          packages: ['geochart'],
          mapsApiKey: _vm.$config.MAPS_API_KEY,
        },"create-chart":_vm.createChart}}),_vm._v(" "),_c('v-col',{staticClass:"pt-0 pl-0 justify-start",attrs:{"cols":"12"}},[_vm._v("\n        "+_vm._s(_vm.$t('modules.dashboard.impactGoalPerf.geo.legend'))+"\n      ")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }